<template>
    <v-container>
        <v-row class="mb-4">
            <v-col cols="12" md="6" sm="12">
                <v-card elevation="2" class="mb-4">
                    <v-card-text>
                        <p>P2P Dollar Rate</p>
                        <p><strong>N{{ p2p }}</strong></p>
                    </v-card-text>


                </v-card>
                <v-card elevation="2">
                    <v-card-text>
                        <p>Official Dollar Rate</p>
                        <p><strong>N{{ official }}</strong></p>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" sm="12">
                <v-card elevation="2" class="mb-4">
                    <v-card-text>
                        <p>Switch Rate</p>
                        <v-radio-group v-model="active" @change="updatingRate" column>
                            <v-radio :disabled="!can('can_alter_crypto_manager')" label="P2P Rates" value="p2p-dollar-rate"></v-radio>
                            <v-radio :disabled="!can('can_alter_crypto_manager')" label="Official Rates" value="official-dollar-rate"></v-radio>
                        </v-radio-group>

                    </v-card-text>


                </v-card>

            </v-col>
        </v-row>
        <v-card class="mb-5">


            <v-row class="pl-5 pt-3">
                <v-col>
                    <span style="font-size: large;" class=" mr-7">Wallet</span>

                </v-col>
                <v-col class="pr-5"> <button @click="downloadCsv" v-if="coins.length != 0 && this.loading == false"
                        class="dt-orange white--text pa-2 rounded float-right">Download</button></v-col>



            </v-row>

            <div>
                <br><br>
                <dtunes-loader :loading="loading"></dtunes-loader>
                <manager-table :coins="coins"></manager-table>
                <dtunes-empty v-if="coins.length == 0 && this.loading == false">
                    <template v-slot:title>
                        No Wallet Available
                    </template>
                    <template v-slot:sub-title>
                       
                    </template>
                </dtunes-empty>
            </div>
        </v-card>

        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        <v-row>
                            <v-col cols="12" sm="12" md="6"> Rate Range List</v-col>
                            <v-col cols="12" sm="6" md="3">
                                <template style="margin-bottom:-10px">
                                    <v-select v-model="selectedCoin" @change="changeCoin" outlined :items="coinNames"
                                        label="wallet"></v-select>
                                </template>
                            </v-col>
                            <v-col v-if="can('can_alter_crypto_manager')" cols="12" sm="6" md="3">
                                <CreateRangeModal :key="createModal" :coins="coins" @refresh="refresh"></CreateRangeModal>
                            </v-col>

                        </v-row>


                    </v-card-title>

                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Coin Name
                                    </th>
                                    <th class="text-left">
                                        Range (From)
                                    </th>
                                    <th class="text-left">
                                        Range (To)
                                    </th>
                                    <th class="text-left">
                                        Rate Input
                                    </th>
                                    <th class="text-left">
                                        Rate Output
                                    </th>
                                    <th>
                                        charges
                                    </th>
                                    <th v-if="can('can_alter_crypto_manager')" class="text-left">
                                        Actions
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in activeCoin.rates" :key="item.id">
                                    <td>{{ activeCoin.coinName }}</td>
                                    <td>${{ item.min }}</td>
                                    <td>${{ item.max }}</td>
                                    <td> {{ Number(Number(item.value) + Number(item.confirmation_charge)).toFixed(2) }} /$
                                    </td>
                                    <td> {{ Number(item.value).toFixed(2) }} /$</td>
                                    <td>{{ Number(item.confirmation_charge).toFixed(2) }}</td>
                                    <td v-if="can('can_alter_crypto_manager')" style="color:orange" color="auto">
                                        <editRangeModal :name="activeCoin.coinName" :rate="item">
                                        </editRangeModal>
                                        <confirmationDialog @reload="deleteRefresh" :rate="item"></confirmationDialog>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>

// import sound from '@/assets/Global/Sounds/notify.wav'

// =========== IMPORT SERVICE =========
import { StoresService } from "@/services";
import { CryptoService } from "@/services";
import app from '@/main'



import DtunesLoader from "@/components/dtunes-loader.vue"
import DtunesEmpty from "@/components/dtunes-empty.vue"
import CreateRangeModal from '../components/create-range-modal';
import editRangeModal from '../components/edit-range-modal';
import managerTable from '../components/manager-table.vue';
import confirmationDialog from "../components/delete-confirmation.vue";


export default {
    data: () => ({
        topTradersUsers: [],
        loading: true,
        p2p: 1,
        official: 1,
        active: '',
        coins: [],
        createModal: 0,
        selectedCoin: '',
        activeCoin: {},
        coinRange: [],
        search: '',
        headers: [
            { text: 'Wallet', value: 'wallet' },
            { text: 'status', value: 'status' },
            { text: 'confirmation change', value: 'change' },
            { text: 'Naira Equivalent', value: 'naira' },
            { text: 'edit' },
            { text: 'action' }
        ],
        coinNames: []
    }),
    async mounted() {
        this.reload();
        this.retrieveSettings();
    },
    methods: {
        async reload() {
            // this.getTopTraders();
            this.getAllCoins();
            setTimeout(() => {
                this.createModal = 0
            }, 1000)
        },
        async deleteRefresh() {
            await this.getAllCoins();
            await this.changeCoin();
        },
        async updatingRate() {
            try {
                let setting = { key: "active-dollar-rate", value: this.active };
                let data = await CryptoService.updateDollarRates(setting);
                if (data) {
                    app.$store.dispatch('toast', {
                        message: 'Rate source updated',
                        variant: 'success'
                    })
                }
                console.log(this.active)
            } catch (error) {
                console.log(error);
            }
        },
        async refresh() {
            this.createModal = 1;
            await this.getAllCoins();
            await this.changeCoin();
            setTimeout(() => {
                this.createModal = 0
            }, 500)
            // this.reload();
        },
        async getTopTraders() {
            try {
                this.
                    topTradersUsers = [];
                this.loading = true;
                let data = await StoresService.loadTopTraders();
                this.loading = false;
                this.topTradersUsers = data;
            } catch (error) {
                this.loading = false;
            }
        },

        async getAllCoins() {
            this.loading = true;
            let data = await CryptoService.getCoins();
            if (data) {
                this.loading = false;
                this.coins = data;
                this.coins.forEach((coin) => {
                    this.coinNames.push(coin.coinName);
                    if (coin.isAvailable == true) this.activeCoin = coin;
                });

            }
        },
        convertToCsv(jsonData) {
            const separator = ',';
            const keys = Object.keys(jsonData[0]);
            const csvHeader = keys.join(separator);
            const csvRows = jsonData.map(item => {
                const values = keys.map(key => item[key]);
                return values.join(separator);
            });
            return csvHeader + '\n' + csvRows.join('\n');
        },
        downloadCsv() {

            const csvData = this.convertToCsv(this.coins);
            const blob = new Blob([csvData], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'data.csv';
            link.click();
        },

        async retrieveSettings() {
            try {
                let data = await CryptoService.retrieveRates();
                console.log("the new file", data);
                data.forEach((rate) => {
                    if (rate.key == 'p2p-dollar-rate') this.p2p = rate.value;
                    if (rate.key == 'official-dollar-rate') this.official = rate.value;
                    if (rate.key == 'active-dollar-rate') this.active = rate.value;

                })
            } catch (error) {
                console.log(error);
            }
        },
        async changeCoin() {
            this.coins.forEach((coin) => {
                if (coin.coinName == this.selectedCoin) {
                    this.activeCoin = coin;
                    return;
                }
            })
        }
    },
    components: {
        CreateRangeModal,
        editRangeModal,
        DtunesEmpty,
        DtunesLoader,
        // securityPinModal,
        managerTable,
        confirmationDialog
    },
};
</script>

<style>
#table {
    max-height: 400px;
    /* Set the desired maximum height */
    overflow-y: auto;
    /* Enable vertical scrolling */
}

.logo-container {
    display: flex;
    align-items: center;
}

.logo-container img {
    margin-right: 10px;
    width: 20px;
    height: 20px;
    /* add margin if necessary */
}

.logo-text {
    font-size: 18px;
    /* adjust font size as needed */
}
</style>


